import React from 'react';
import { useHistory } from 'react-router-dom';

import { ApButtonSecondary, ApButtonMain } from '@alixpartners/ui-components';

import { StyledModal } from './WarningDialog.styles';

export const WarningDialog = ({ onClose }) => {
	const history = useHistory();
	const goToUpload = () => {
		history.push('/data');
	};

	return (
		<StyledModal
			header="Taxonomy application is temporarily blocked"
			footer={() => (
				<React.Fragment>
					<ApButtonSecondary theme="light" onClick={goToUpload}>
						Check upload page
					</ApButtonSecondary>
					<ApButtonMain theme="light" onClick={onClose}>
						Ok
					</ApButtonMain>
				</React.Fragment>
			)}
			hasClosed={onClose}
			isDismissible
			isOpen
		>
			We cannot apply the taxonomy while a new data upload is being processed.
			Please try to reapply the taxonomy in a few minutes.
		</StyledModal>
	);
};
